
import $ from 'jquery';
import {register} from './../exports/theme-sections';
import parallaxImage from './../exports/parallaxImage';
import slickSlider from './../features/slick-slider';



register('blog', [slickSlider, parallaxImage]);
